import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NewsletterForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "" });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t("home.newsletter.errorRequired");
    if (!values.email.trim()) e.email = t("home.newsletter.errorRequired");
    else if (!EMAIL_RE.test(values.email.trim()))
      e.email = t("home.newsletter.errorEmail");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    navigate("/thank_you");
  };

  return (
    <form
      data-testid="newsletter-form"
      onSubmit={onSubmit}
      noValidate
      className="grid grid-cols-1 gap-4"
    >
      <div>
        <label
          htmlFor="newsletter-name"
          className="block text-xs font-mono uppercase tracking-widest text-[#0A192F]"
        >
          {t("home.newsletter.nameLabel")}
        </label>
        <input
          id="newsletter-name"
          data-testid="newsletter-name-input"
          type="text"
          value={values.name}
          onChange={(e) => setValues((v) => ({ ...v, name: e.target.value }))}
          placeholder={t("home.newsletter.namePlaceholder")}
          className="mt-2 block w-full rounded-sm border border-[#0A192F]/15 bg-white px-4 py-3 text-sm text-[#0A192F] placeholder:text-[#94A3B8] focus:border-[#059669] focus:outline-none focus:ring-2 focus:ring-[#059669]/25"
        />
        {errors.name && (
          <p
            data-testid="newsletter-name-error"
            className="mt-1 text-xs text-[#B45309]"
          >
            {errors.name}
          </p>
        )}
      </div>

      <div>
        <label
          htmlFor="newsletter-email"
          className="block text-xs font-mono uppercase tracking-widest text-[#0A192F]"
        >
          {t("home.newsletter.emailLabel")}
        </label>
        <input
          id="newsletter-email"
          data-testid="newsletter-email-input"
          type="email"
          value={values.email}
          onChange={(e) => setValues((v) => ({ ...v, email: e.target.value }))}
          placeholder={t("home.newsletter.emailPlaceholder")}
          className="mt-2 block w-full rounded-sm border border-[#0A192F]/15 bg-white px-4 py-3 text-sm text-[#0A192F] placeholder:text-[#94A3B8] focus:border-[#059669] focus:outline-none focus:ring-2 focus:ring-[#059669]/25"
        />
        {errors.email && (
          <p
            data-testid="newsletter-email-error"
            className="mt-1 text-xs text-[#B45309]"
          >
            {errors.email}
          </p>
        )}
      </div>

      <p className="text-xs leading-relaxed text-[#64748B]">
        {t("home.newsletter.consent")}
      </p>

      <button
        data-testid="newsletter-submit"
        type="submit"
        className="w-full rounded-sm bg-[#059669] px-5 py-3 text-sm font-semibold uppercase tracking-wider text-white hover:bg-[#047857]"
      >
        {t("home.newsletter.submit")}
      </button>
    </form>
  );
}
